import { render, staticRenderFns } from "./sizeFilter.vue?vue&type=template&id=42bcbf8f&scoped=true"
import script from "./sizeFilter.vue?vue&type=script&lang=js"
export * from "./sizeFilter.vue?vue&type=script&lang=js"
import style0 from "./sizeFilter.vue?vue&type=style&index=0&id=42bcbf8f&prod&lang=scss&scoped=true"
import style1 from "./sizeFilter.vue?vue&type=style&index=1&id=42bcbf8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bcbf8f",
  null
  
)

export default component.exports